import React from "react";
import styled from "styled-components";

export default styled.div`
    background: white;
    position: absolute;
    bottom: 15px;
    left: 100px;
    width: 560px;
    height: 270px;
    z-index: 20;
    display: none;
    padding: 23px;
    box-shadow: 5px 5px 25px rgb(0 0 0 / 29%);
    
    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;